import { useState } from "react";
import { discussions } from "@/mocks/homeContent";
import SectionHeading from "./SectionHeading";

const hotTopics = ["社团经费", "时间线", "宿舍矛盾", "兼职押金", "期末评分"];

const rules = [
  "不公开他人真实信息与联系方式",
  "以可核对的材料为依据，不靠情绪下结论",
  "涉及当事人的情况，给对方澄清的机会",
  "发现不实内容可点击举报，我们会复核",
];

export default function DiscussionBoard() {
  const [liked, setLiked] = useState<Record<string, boolean>>({});

  const toggleLike = (id: string) => {
    setLiked((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <section id="discussion" className="w-full scroll-mt-20 bg-background-100 px-4 py-10 md:px-8 md:py-14">
      <SectionHeading
        eyebrow="社区讨论"
        title="瓜可以一起吃，话得好好说"
        desc="这里是学生圈最热闹的讨论区，黑料学生瓜的最新进展往往先在评论区被补齐，也最先被质疑。"
        action={{ label: "进入讨论区", href: "#discussion" }}
      />

      <div className="grid gap-6 lg:grid-cols-12 lg:gap-8">
        <div className="flex flex-col gap-4 lg:col-span-8">
          {discussions.map((item) => (
            <article
              key={item.id}
              className="rounded-lg border border-background-200/70 bg-background-50 p-4 md:p-5"
            >
              <header className="flex items-center gap-3">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                  <i className="ri-user-smile-line text-lg"></i>
                </span>
                <div className="flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="text-sm font-medium text-foreground-900">{item.author}</span>
                    <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[10px] font-medium text-secondary-900">
                      {item.badge}
                    </span>
                  </div>
                  <span className="text-[11px] text-foreground-400">{item.time}</span>
                </div>
                <span className="hidden items-center gap-1 rounded-full bg-background-100 px-2.5 py-0.5 text-[11px] text-foreground-600 sm:inline-flex">
                  <span className="flex h-3 w-3 items-center justify-center">
                    <i className="ri-price-tag-3-line text-xs"></i>
                  </span>
                  {item.topic}
                </span>
              </header>

              <p className="mt-3 text-sm leading-relaxed text-foreground-700">{item.content}</p>

              <footer className="mt-3.5 flex items-center gap-5 border-t border-background-200/70 pt-3">
                <button
                  type="button"
                  onClick={() => toggleLike(item.id)}
                  className={`flex cursor-pointer items-center gap-1.5 text-xs transition-colors ${
                    liked[item.id] ? "text-primary-600" : "text-foreground-500 hover:text-primary-600"
                  }`}
                >
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    <i className={liked[item.id] ? "ri-heart-fill text-sm" : "ri-heart-line text-sm"}></i>
                  </span>
                  {item.likes + (liked[item.id] ? 1 : 0)}
                </button>
                <span className="flex items-center gap-1.5 text-xs text-foreground-500">
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    <i className="ri-chat-3-line text-sm"></i>
                  </span>
                  {item.replies} 条回复
                </span>
                <span className="ml-auto flex cursor-pointer items-center gap-1.5 text-xs text-foreground-500 transition-colors hover:text-primary-600">
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    <i className="ri-reply-line text-sm"></i>
                  </span>
                  参与讨论
                </span>
              </footer>
            </article>
          ))}
        </div>

        <aside className="flex flex-col gap-4 lg:col-span-4">
          <div className="rounded-lg border border-background-200/70 bg-background-50 p-4 md:p-5">
            <h3 className="flex items-center gap-2 text-sm font-semibold text-foreground-900">
              <span className="flex h-4 w-4 items-center justify-center text-secondary-600">
                <i className="ri-shield-check-line text-base"></i>
              </span>
              讨论区规则
            </h3>
            <ul className="mt-3 flex flex-col gap-2.5">
              {rules.map((rule) => (
                <li key={rule} className="flex gap-2.5 text-[13px] leading-relaxed text-foreground-600">
                  <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-primary-400"></span>
                  <span>{rule}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-lg border border-background-200/70 bg-background-50 p-4 md:p-5">
            <h3 className="flex items-center gap-2 text-sm font-semibold text-foreground-900">
              <span className="flex h-4 w-4 items-center justify-center text-primary-500">
                <i className="ri-fire-line text-base"></i>
              </span>
              正在热议
            </h3>
            <div className="mt-3 flex flex-wrap gap-2">
              {hotTopics.map((topic) => (
                <a
                  key={topic}
                  href="#discussion"
                  className="cursor-pointer rounded-full border border-background-300/70 bg-background-100 px-3 py-1 text-xs text-foreground-700 transition-colors hover:border-primary-200 hover:text-primary-600 whitespace-nowrap"
                >
                  #{topic}
                </a>
              ))}
            </div>
          </div>
        </aside>
      </div>
    </section>
  );
}